import moment from 'moment';
import React from 'react';
import { Link } from 'react-router-dom';
import { BlogPostSummary } from '../../../../common/graphql/blogs/blogpost';
import { CardContainer, CardIntro, CardDate, CardImage, CardTexts, CardTitle } from './styles/blogCard.styles';

interface Props {
  blog: BlogPostSummary;
  blogLinkPrefix: string;
}

const BlogPostCard: React.FC<Props> = ({ blog, blogLinkPrefix }) => {
  return (
    <Link to={`${blogLinkPrefix}/${blog.slug}`}>
      <CardContainer>
        <CardImage url={blog.thumbnailUrl} />
        <CardTexts>
          <CardDate>{moment.utc(blog.createdAt).format('MMMM DD, YYYY')}</CardDate>
          <CardTitle>{blog.title}</CardTitle>
          <CardIntro>{blog.intro}</CardIntro>
        </CardTexts>
      </CardContainer>
    </Link>
  );
};

export default BlogPostCard;
